import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { NavExtrasService } from '../data.service';
import { ConfigService } from '../config.service';
import { AnalyticsService } from '../analytics.service';

@Component({
  selector: 'app-voting-info',
  templateUrl: './voting-info.page.html',
  styleUrls: ['./voting-info.page.scss'],
})
export class VotingInfoPage implements OnInit {

  constructor(
    private navController: NavController,
    private navExtraService: NavExtrasService,
    private configService: ConfigService,
    private analyticsService: AnalyticsService
    ) {}

    headerBranding: String;
    isBallotpediaWebApp: Boolean;
    collectAnalytics: Boolean;

    stateName: String;
    stateAbbreviation: String;
    votingInfo: any;


  async ngOnInit() {
    let res = await this.configService.getConfiguration();
    this.headerBranding = res["headerBranding"];
    this.isBallotpediaWebApp = res["isBallotpediaWebApp"];
    this.collectAnalytics = res["collectAnalytics"];

    this.stateName = this.navExtraService.getStateNameAndAbbreviation().stateName;
    this.stateAbbreviation = this.navExtraService.getStateNameAndAbbreviation().stateAbbreviation;
    this.votingInfo = this.navExtraService.getVotingInfo();

  }

  onContinueToBallot() {
  
    if(this.collectAnalytics) {
      this.analyticsService.trackEvent('view results');
    }

    this.navController.navigateForward(`/ballot`);
  }

  visitExternalLink() {

    let URL = `https://ballotpedia.org/voting_in_${this.stateName.replace(' ', '_')}`;
    window.open(URL, `_system`);
  }

}
